<script>
const BANK_NAMES = {
  '002': 'ธนาคารกรุงเทพ',
  '004': 'ธนาคารกสิกรไทย',
  '006': 'ธนาคารกรุงไทย',
  '011': 'ธนาคารทหารไทยธนชาต',
  '014': 'ธนาคารไทยพาณิชย์',
  '022': 'ธนาคารซีไอเอ็มบี ไทย',
  '024': 'ธนาคารยูโอบี',
  '025': 'ธนาคารกรุงศรีอยุธยา',
  '030': 'ธนาคารออมสิน',
  '033': 'ธนาคารอาคารสงเคราะห์',
  '034': 'ธ.ก.ส.',
  '066': 'ธนาคารอิสลามแห่งประเทศไทย',
  '067': 'ธนาคารทิสโก้',
  '069': 'ธนาคารเกียรตินาคินภัทร',
  '070': 'ธนาคารไอซีบีซี (ไทย)',
  '071': 'ธนาคารไทยเครดิต',
  '073': 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
}

export default {
  name: 'NexvoDepositInstructions',
  props: {
    amount: {
      type: [Number, String],
      required: true,
    },
    channel: {
      type: String,
      default: '',
    },
    qrImage: {
      type: String,
      default: '',
    },
    qrImageLink: {
      type: String,
      default: '',
    },
    bankCode: {
      type: String,
      default: '',
    },
    accountNo: {
      type: String,
      default: '',
    },
    accountName: {
      type: String,
      default: '',
    },
    expireTime: {
      type: String,
      default: '',
    },
  },
  computed: {
    isPromptPay(){
      return this.channel === 'PROMPTPAY'
    },
    qrSource(){
      if(this.qrImage){
        return this.qrImage.startsWith('data:image')
          ? this.qrImage
          : `data:image/png;base64,${this.qrImage}`
      }
      return this.qrImageLink
    },
    bankName(){
      return BANK_NAMES[this.bankCode] || this.bankCode || '-'
    },
    formattedAmount(){
      return Number(this.amount || 0).toLocaleString('th-TH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
</script>

<template>
  <section class="nexvo-deposit">
    <header class="nexvo-deposit__header">
      <p class="nexvo-deposit__provider">Nexvo Payment</p>
      <h4 class="nexvo-deposit__title">
        {{ isPromptPay ? 'สแกน QR Code เพื่อฝากเงิน' : 'โอนเงินเข้าบัญชีด้านล่าง' }}
      </h4>
      <p class="nexvo-deposit__amount">{{ formattedAmount }} บาท</p>
    </header>

    <div v-if="isPromptPay && qrSource" class="nexvo-deposit__qr-frame">
      <img :src="qrSource" class="nexvo-deposit__qr" alt="Nexvo PromptPay QR Code">
    </div>

    <dl class="nexvo-deposit__details">
      <div class="nexvo-deposit__row">
        <dt>ธนาคาร</dt>
        <dd>{{ bankName }}</dd>
      </div>
      <div class="nexvo-deposit__row">
        <dt>เลขบัญชี</dt>
        <dd class="nexvo-deposit__account">{{ accountNo || '-' }}</dd>
      </div>
      <div class="nexvo-deposit__row">
        <dt>ชื่อบัญชี</dt>
        <dd>{{ accountName || '-' }}</dd>
      </div>
    </dl>

    <p class="nexvo-deposit__notice">
      กรุณาโอนจากบัญชีที่ลงทะเบียนไว้และใช้รายการนี้เพียงครั้งเดียว
      <span v-if="expireTime">รายการหมดอายุ {{ expireTime }}</span>
    </p>
  </section>
</template>

<style scoped>
.nexvo-deposit {
  width: min(440px, calc(100% - 20px));
  margin: 20px auto;
  padding: 24px;
  border-radius: 20px;
  background: linear-gradient(145deg, #0a2540, #1565c0);
  box-shadow: 0 12px 30px rgba(10, 37, 64, .3);
  color: #fff;
  font-family: 'Kanit', sans-serif;
}

.nexvo-deposit__header {
  margin-bottom: 18px;
  text-align: center;
}

.nexvo-deposit__provider {
  margin: 0 0 4px;
  color: #a9d6ff;
  font-size: 12px;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.nexvo-deposit__title {
  margin: 0;
  font-size: 21px;
  font-weight: 600;
}

.nexvo-deposit__amount {
  margin: 8px 0 0;
  color: #ffd54f;
  font-size: 25px;
  font-weight: 700;
}

.nexvo-deposit__qr-frame {
  width: min(310px, 100%);
  margin: 0 auto 18px;
  padding: 14px;
  border-radius: 16px;
  background: #fff;
}

.nexvo-deposit__qr {
  display: block;
  width: 100%;
  height: auto;
}

.nexvo-deposit__details {
  margin: 0;
  overflow: hidden;
  border-radius: 12px;
  background: rgba(255, 255, 255, .12);
}

.nexvo-deposit__row {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 12px;
  padding: 11px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, .12);
}

.nexvo-deposit__row:last-child {
  border-bottom: 0;
}

.nexvo-deposit__row dt {
  margin: 0;
  color: #b9d9f4;
  font-weight: 400;
}

.nexvo-deposit__row dd {
  margin: 0;
  overflow-wrap: anywhere;
  text-align: right;
}

.nexvo-deposit__account {
  color: #ffd54f;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: .04em;
}

.nexvo-deposit__notice {
  display: flex;
  margin: 15px 0 0;
  flex-direction: column;
  color: #d6eaff;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 480px) {
  .nexvo-deposit {
    padding: 18px;
  }

  .nexvo-deposit__title {
    font-size: 18px;
  }

  .nexvo-deposit__row {
    grid-template-columns: 78px minmax(0, 1fr);
  }
}
</style>
